(function() {
    angular.module('emarket.main.home').controller('WelcomeDialogController', ['$mdDialog', function($mdDialog) {
        var vm = this;
        vm.close = function close() {
            $mdDialog.hide();
        };
    }]);
}());
